import React from "react";
import constant from "../../../constants/constant";

interface EcommerceStatusBadgeProps {
  status: number;
}

const EcommerceStatusBadge: React.FC<EcommerceStatusBadgeProps> = ({ status }) => {
  if (status === constant.ECOMMERCE_STATUS[1].value) {
    return (
      <div className="background-light-yellow border-product-radius">
        <p className="color-yellow m-1 p-1">Offline</p>
      </div>
    );
  }

  if (status === constant.ECOMMERCE_STATUS[0].value) {
    return (
      <div className="background-light-green border-product-radius">
        <p className="color-green m-1 p-1">Online</p>
      </div>
    );
  }

  return null;
};

export default EcommerceStatusBadge;
